import React, { useState } from "react";
import { getYouTubeVideoId } from "../utils/helpers";
import { PlayIcon } from "../components/Icons";
import { InlineShareButtons } from "../components/ShareButton";
import MetaTags from "../components/MetaTags";
import ReelPlayerModal from "../components/ReelPlayerModal";

const ShortsPage = ({ allArticles, lang }) => {
  const shortArticles = allArticles.filter((a) => a.shortVideo);
  const [selectedReel, setSelectedReel] = useState(null);

  return (
    <main className="flex-grow container mx-auto px-4 py-8">
      <MetaTags
        title="Shorts"
        description="Watch short news clips, reels, and quick updates from Amdavad Post."
      />
      <h1 className="text-3xl font-bold mb-6 capitalize border-b-2 border-red-600 pb-2">
        Shorts
      </h1>
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
        {shortArticles.map((reel) => (
          <div
            key={reel.id}
            className="group cursor-pointer"
            onClick={() => setSelectedReel(reel)}
          >
            <div className="relative rounded-lg overflow-hidden aspect-[9/16] bg-gray-700">
              <img
                src={`https://img.youtube.com/vi/${getYouTubeVideoId(
                  reel.shortVideo
                )}/mqdefault.jpg`}
                alt={reel.title}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black/40"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <PlayIcon />
              </div>
            </div>
            <h4 className="mt-2 font-semibold text-sm h-10">
              {reel.title}
            </h4>
            <div className="flex justify-end" onClick={(e) => e.stopPropagation()}>
              <InlineShareButtons
                url={`${window.location.origin}/news/${reel.slug || reel.id}`}
                title={reel.title}
              />
            </div>
          </div>
        ))}
      </div>
      <ReelPlayerModal
        reel={selectedReel}
        onClose={() => setSelectedReel(null)}
        lang={lang}
      />
    </main>
  );
};

export default ShortsPage;
